<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <vs-sidebar :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" click-not-close parent="#email-app" position-right v-model="isSidebarActive">
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentMail">
        <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
              <h4 v-if="currentMail.subject">{{ currentMail.subject }}</h4>
              <h4 v-else>(no subject)</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="email__actions--single flex items-baseline">

              <feather-icon :svgClasses="[{'text-warning stroke-current stroke-current': currentMail.isStarred}, 'h-6 w-6']" @click="toggleIsStarred" class="cursor-pointer" icon="StarIcon"/>

              <!-- MOVE TO DROPDOWN -->
              <vs-dropdown class="cursor-pointer" v-if="mailFilter != 'sent'" vs-custom-content vs-trigger-click>
                <feather-icon class="ml-4" icon="FolderIcon" svg-classes="h-6 w-6"></feather-icon>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="moveTo('inbox')" v-if="currentMail.mailFolder != 'inbox'">
                                    <span class="flex items-center">
                                      <feather-icon class="mr-2" icon="MailIcon" svgClasses="h-4 w-4"/>
                                      <span>Inbox</span>
                                    </span>
                  </vs-dropdown-item>

                  <vs-dropdown-item @click="moveTo('draft')" v-if="currentMail.mailFolder != 'draft'">
                                    <span class="flex items-center">
                                      <feather-icon class="mr-2" icon="Edit2Icon" svgClasses="h-4 w-4"/>
                                      <span>Draft</span>
                                    </span>
                  </vs-dropdown-item>

                  <vs-dropdown-item @click="moveTo('spam')" v-if="currentMail.mailFolder != 'spam'">
                                    <span class="flex items-center">
                                      <feather-icon class="mr-2" icon="InfoIcon" svgClasses="h-4 w-4"/>
                                      <span>Spam</span>
                                    </span>
                  </vs-dropdown-item>

                  <vs-dropdown-item @click="moveTo('trash')" v-if="currentMail.mailFolder != 'trash'">
                                    <span class="flex items-center">
                                      <feather-icon class="mr-2" icon="TrashIcon" svgClasses="h-4 w-4"/>
                                      <span>Trash</span>
                                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <!-- ADD LABEL DROPDOWN -->
              <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
                <feather-icon class="cursor-pointer ml-4" icon="TagIcon" svg-classes="h-6 w-6"></feather-icon>
                <vs-dropdown-menu style="z-index: 40001">
                  <vs-dropdown-item :key="index" @click.stop v-for="(label, index) in emailTags">
                    <vs-checkbox :vs-value="label.value" v-model="currentMailLabels">{{ label.text }}</vs-checkbox>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <feather-icon @click="$emit('markUnread')" class="cursor-pointer ml-4" icon="MailIcon" svg-classes="h-6 w-6"></feather-icon>
              <feather-icon @click="$emit('removeMail')" class="cursor-pointer ml-4" icon="TrashIcon" svg-classes="h-6 w-6" v-if="currentMail.mailFolder != 'trash'"></feather-icon>
              <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" @click="$emit('previousMail')" class="cursor-pointer ml-4 hidden sm:inline-flex" svg-classes="h-6 w-6"/>
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" @click="$emit('nextMail')" class="cursor-pointer ml-4 hidden sm:inline-flex" svg-classes="h-6 w-6"/>
            </div>
          </div>
        </div>

        <component :is="scrollbarTag" :key="$vs.rtl" :settings="settings" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6">
          <!-- LABEL ROW -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="email__labels--single flex ml-10 items-center mt-2">
                <transition-group class="flex" name="list" tag="div">
                  <div :key="label" class="open-mail-label flex items-center mr-4" v-for="label in currentMail.labels">
                    <div :class="'bg-' + labelColor(label)" class="h-3 w-3 rounded-full mr-1"></div>
                    <span class="text-sm">{{ label | capitalize }}</span>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
          <!-- /LABEL ROW -->
          <br>

          <div class="vx-row mb-4" v-if="currentMail.replies.length && !showThread">
            <div class="vx-col w-full">
              <span @click="showThread = true" class="text-primary font-medium ml-10 cursor-pointer">{{ currentMail.replies.length }} Earlier Messages</span>
            </div>
          </div>
          <div v-if="isSidebarActive">

            <!-- ALL MESSAGES - THREAD -->
            <div :key="threadMail.id" class="vx-row" v-for="threadMail in currentMail.replies.slice().reverse()" v-if="showThread">
              <div class="vx-col w-full">
                <email-mail-card :mailContent="threadMail" class="mb-10"/>
              </div>
            </div>

            <!-- LATEST MESSAGE -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <email-mail-card :mailContent="currentMail"/>
              </div>
            </div>

            <div class="vx-row" style="margin-top: 2.2rem">
              <div class="vx-col w-full">
                <vx-card>
                  <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                      <span class="text-lg">Click here to <span class="text-primary font-semibold cursor-pointer">Reply</span> or <span class="text-primary font-semibold cursor-pointer">Forward</span></span>
                      <feather-icon icon="PaperclipIcon"></feather-icon>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import EmailMailCard from './EmailMailCard.vue'

  export default {
    props:      {
      emailTags:       {
        type:     Array,
        required: true
      },
      openMailId:      {
        required:  true,
        validator: prop => typeof prop === 'number' || prop === null
      },
      isSidebarActive: {
        type:     Boolean,
        required: true
      },
      mailFilter:      {
        type: String
      }
    },
    data ()
    {
      return {
        showThread: false,
        settings:   {
          maxScrollbarLength: 60,
          wheelSpeed:         0.50
        }
      }
    },
    watch:      {
      isSidebarActive (value)
      {
        if (!value)
        {
          this.$emit('closeSidebar')
          setTimeout(() => {
            this.showThread = false
          }, 500)
        }
      }
    },
    computed:   {
      currentMail ()
      {
        return this.$store.getters['email/getMail'](this.openMailId)
      },
      labelColor ()
      {
        return (label) => {
          const tags = this.$store.state.email.mailTags
          return tags.find((tag) => {
            return tag.value === label
          }).color
        }
      },
      currentMailLabels: {
        get ()
        {
          return this.currentMail.labels
        },
        set (value)
        {
          if (Array.isArray(value))
          {
            const payload = {mailId: this.openMailId, labels: value}
            this.$store.dispatch('email/setLabels', payload)
          }
        }
      },
      scrollbarTag () { return this.$store.getters.scrollbarTag }
    },
    methods:    {
      toggleIsStarred ()
      {
        const payload = {mailId: this.openMailId, value: !this.currentMail.isStarred}
        this.$store.dispatch('email/toggleIsMailStarred', payload)
      },
      moveTo (to)
      {
        this.$emit('closeSidebar')
        this.$emit('moveTo', to)
      }
    },
    components: {
      VuePerfectScrollbar,
      EmailMailCard
    },
    updated ()
    {
      if (!this.currentMail) return
      if (this.currentMail.unread && this.isSidebarActive) this.$store.dispatch('email/setUnread', {
        emailIds: [this.openMailId],
        unread:   false
      })
    }
  }

</script>

